import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ErrorState {
  message: string | null;
  isVisible: boolean;
}

const initialState: ErrorState = {
  message: null,
  isVisible: false,
};

const errorSlice = createSlice({
  name: "error",
  initialState,
  reducers: {
    showError: (state, action: PayloadAction<string>) => {
      state.message = action.payload;
      state.isVisible = true;
    },
    hideError: (state) => {
      state.message = null;
      state.isVisible = false;
    },
  },
});

export const { showError, hideError } = errorSlice.actions;
export default errorSlice.reducer;
